import template from './goldupgrade.html';
import controller from './goldupgrade.controller';

let goldupgradeComponent = {
    restrict: 'E',
    require: {
        "booking": "^booking"
    },
    bindings: {
        "status": "<"
    },
    template,
    controller,
    controllerAs: "vm"
};

export default goldupgradeComponent;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/goldupgrade/goldupgrade.component.js